module.exports = __webpack_public_path__ + "static/media/Spearow_gaussian2.54f6b29f.png";